import {create} from 'zustand';

export interface ShareButtonState {
  isModalOpen: boolean;
}

interface ShareButtonStore extends ShareButtonState {
  openModal: () => void;
  closeModal: () => void;
  resetState: () => void;
}

const INITIAL_STATE: ShareButtonState = {
  isModalOpen: false,
};

export const useShareButtonStore = create<ShareButtonStore>(set => ({
  ...INITIAL_STATE,

  openModal: () => set({isModalOpen: true}),
  closeModal: () => set({isModalOpen: false}),

  resetState: () => set(INITIAL_STATE),
}));
